export const translateFieldName = (originalFieldName: string): string => {
  switch (originalFieldName) {
    case 'building_id':
    case 'area_id':
    case 'level_id':
      return 'location';
    case 'images':
      return 'photographs';
    case 'result':
      return 'rating';
    default:
      return originalFieldName;
  }
};

export const translateFieldNameToOriginal = (translatedFieldName: string): string => {
  switch (translatedFieldName) {
    case 'rating':
      return 'result';
    case 'photographs':
      return 'images';
  }
  return translatedFieldName;
};